module.exports = __webpack_public_path__ + "img/client-tab.f4eb055d.svg";